import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface ConfirmationDialogProps {
  title: string;
  description: string;
  onAccept: () => void;
  onClose: () => void;
  open: boolean;
  acceptLabel?: string;
  acceptColor?: "error" | "primary" | "warning";
}

export function ConfirmationDialog({
  title,
  description,
  onAccept,
  onClose,
  open,
  acceptLabel = "Delete",
  acceptColor = "error",
}: ConfirmationDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ minWidth: "400px" }}>
        <Typography variant="subtitle2">
          {description}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={onClose} 
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={() => onAccept()}
          sx={{ color: "white" }}
          variant="contained"
          color={acceptColor}
        >
          {acceptLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
